export const currentUser = (state) => state.currentUser
export const currentShop = (state) => state.currentShop
export const getUsers = (state) => state.users
export const getCompanyInfo = (state) => state.companyInfo

